/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Investor_StrategyInputs */

const cs_investor_strategy = /** @type {(inputs: Investor_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategie`)
};

const en_investor_strategy = /** @type {(inputs: Investor_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy`)
};

/**
* | output |
* | --- |
* | "Strategy" |
*
* @param {Investor_StrategyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const investor_strategy = /** @type {((inputs?: Investor_StrategyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Investor_StrategyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_investor_strategy(inputs)
	return cs_investor_strategy(inputs)
});